import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressBar", "statusBadge", "progressText"]
  static values = {
    companyId: Number,
    url: String
  }

  connect() {
    // No automatic polling - user will refresh page for updates
    console.log('Sync status controller connected - page refresh required for status updates')
  }

  disconnect() {
    // No cleanup needed since we're not polling
  }

  // Manual refresh action - reloads the entire page
  refresh() {
    window.location.reload()
  }

  // Start sync action - can be triggered by buttons
  async startSync(event) {
    const syncType = event.target.dataset.syncType || 'incremental'
    const companyId = this.companyIdValue

    try {
      const response = await fetch(`/admin/companies/${companyId}/sync_patients`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ sync_type: syncType })
      })

      if (response.ok) {
        // Show message and prepare for page refresh
        alert('Sync started! This will sync patients, then document types, then appointments for today/tomorrow. Please refresh the page to see updated status.')
      } else {
        alert('Failed to start sync. Please try again.')
      }
    } catch (error) {
      console.error('Error starting sync:', error)
      alert('Failed to start sync. Please try again.')
    }
  }
}